import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import React from "react";

export class SupportZipApp extends React.Component<SupportZipAppProps, any> {
    private _gridElementRef = null;
    private _gridRef: kendo.ui.Grid = null;
    private _isDataBound = false;
    private _resourceplanningTables = ["adrtyp", "apind", "auart", "austatus", "feiert", "feldinhalt", "feldinhaltm", "freedays", "indkat", "indkatfelder", "inidb",
        "is_module_access", "kalender", "kalenderid", "kuind", "kunde", "land", "langidx", "lbzliste", "maind", "mapark", "maschgr", "maschogr", "maschtyp", "nachschlag",
        "nachschlagid", "nukreis", "nukreisid", "option_e", "option_eid", "option_g", "option_k", "option_o", "planber", "planung", "plind", "plsteuer", "pltranslate",
        "pltranslatelang", "pspalten", "ptabellen", "pwgrupp", "pwogrupp", "pwuser", "pwzusatz", "reind", "resslist", "spesen", "vkind", "vkunadr", "vkunpart", "vkunzus"];
    common = new AppHelper();
    setTabTitle = true;
    createEnabled = false;
    gridTablesOptions: kendo.ui.GridOptions = null;


    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.common.unloadHelper.disable();
    }

    private _createSubTitle = () => {
        return (
            <div className="page-title form-container__title" style={{ marginTop: 0 }}>
                <label>{this.props.subTitle}</label>
            </div>
        );
    }

    private _setUpGrid = () => {
        this._gridRef = $(this._gridElementRef).kendoGrid(this.gridTablesOptions).data("kendoGrid");
        this._gridRef.dataSource.data(this.props.entity.Tables);

        $(this._gridRef.wrapper).on("click", "#checkboxAllTables, #checkboxResourcePlanningTables, .checkboxTable", (ev) => {
            const $target = $(ev.target);
            const checked = $target.is(":checked");

            if ($target.hasClass("checkboxTable")) {
                const dataItem = this._gridRef.dataItem($target.closest("tr"));
                let found = false;
                let i = 0;
                while (!found && i < this.props.entity.Tables.length) {
                    if (this.props.entity.Tables[i].Name === dataItem.get("Name")) {
                        this.props.entity.Tables[i].Selected = checked;
                        found = true;
                    }
                    i++;
                }
            } else {
                const isAll = $target.attr("id") === "checkboxAllTables";
                this._selectTables(checked, isAll);
            }

            this._updateSelectCheckboxes();
            this._updateCreateButton();
        });
    }

    private _selectTables = (on: boolean, all: boolean) => {
        this.props.entity.Tables.forEach(t => {
            //if all = true => set/unset all tables
            //if all <> true => set/unset only the tables for reasource planning
            if (all || this._resourceplanningTables.indexOf(t.Name) !== -1) {
                t.Selected = on;
            }
        });
        this._gridRef.dataSource.data(this.props.entity.Tables);
    }

    private _updateSelectCheckboxes = () => {
        const selectedStatus = this._getSelectedTablesStatus();
        $("#checkboxAllTables").prop("checked", selectedStatus.all);
        $("#checkboxResourcePlanningTables").prop("checked", selectedStatus.resourcePlanning);
    }

    private _getSelectedTablesStatus = () => {
        let all = false;
        let rp = false;

        const selected = this.props.entity.Tables.filter(t => {
            return t.Selected === true;
        });

        all = selected.length === this.props.entity.Tables.length;

        if (!all) {
            if (selected.length >= this._resourceplanningTables.length) {
                rp = selected.filter(t => {
                    return this._resourceplanningTables.indexOf(t.Name) !== -1;
                }).length === this._resourceplanningTables.length;
            }
        }

        return {
            all: all,
            resourcePlanning: all ? true : rp
        };
    }

    private _updateCreateButton = () => {
        let shouldEnable = false;
        if (this.props.entity.IncludeAppData) {
            shouldEnable = true;
        } else if (this.props.entity.IncludeProtocolfile) {
            shouldEnable = true;
        } else if (this.props.entity.IncludeDbData) {
            if (this.props.entity.Tables.filter(t => { return t.Selected === true; }).length > 0) {
                shouldEnable = true;
            }
        }

        if (shouldEnable !== this.createEnabled) {
            this.createEnabled = shouldEnable;
            this.setState({});
        }
    }


    renderGrid = () => {
        return (
            <div style={{ display: this.props.entity.IncludeDbData ? "block" : "none" }} ref={r => {
                if (Helper.hasValue(r)) {
                    this._gridElementRef = r;
                    if (this._gridRef === null && this.props.entity.IncludeDbData === true) {
                        Helper.setBusyIndicator(true).then(_ => {
                            this._setUpGrid();
                            Helper.setBusyIndicator(false);
                        });

                    }
                }
            }}></div>
        );
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);

        this._updateCreateButton();
    }

    create = () => {
        if (this.common.validate()) {
            const request = new XMLHttpRequest();
            const fileName = "WebSMS_SupportZip.zip";
            request.open('POST', "SupportZip/Create", true);
            request.responseType = 'blob';
            request.setRequestHeader('Accept', 'application/zip');
            request.setRequestHeader("Content-type", "application/json;charset=UTF-8");
            request.onload = () => {
                const link = document.createElement('a');
                document.body.appendChild(link);
                const blob = new Blob([request.response], { type: "application/zip" });
                link.href = URL.createObjectURL(blob);
                Helper.setBusyIndicator(false);
                link.download = fileName;
                link.click();
            };
            request.onerror = () => {
                Helper.setBusyIndicator(false);
                console.log("Zip download error: " + request.statusText);
            }
            Helper.setBusyIndicator(true).then(_ => {
                request.send(JSON.stringify(this.props.entity));
            });
        }
    }


    componentDidMount() {
        this._updateCreateButton();
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} dc3ComponentFunc={this._createSubTitle} />;
    }
}

export interface SupportZipAppProps extends AppBaseProps {
    context: SupportZipContext;
    entity: SupportZipEntity;
    subTitle: string;
}
export interface SupportZipEntity extends Entity {
    IncludeDbData: boolean;
    IncludeAppData: boolean;
    IncludeProtocolfile: boolean;
    Tables: Array<any>;
}

interface SupportZipContext extends Context {
}